var map = {
	"./april.png": 2681,
	"./august.png": 2682,
	"./autumn.png": 2683,
	"./christmas.png": 2684,
	"./december.png": 2685,
	"./easter.png": 2686,
	"./february.png": 2687,
	"./january.png": 2688,
	"./july.png": 2689,
	"./june.png": 2690,
	"./march.png": 2691,
	"./may.png": 2692,
	"./midsummer.png": 2693,
	"./new_year.png": 2694,
	"./november.png": 2695,
	"./november_11.png": 2696,
	"./november_18.png": 2697,
	"./october.png": 2698,
	"./september.png": 2699,
	"./september_1.png": 2700,
	"./spring.png": 2701,
	"./summer.png": 2702,
	"./valentine_day.png": 2703,
	"./winter.png": 2704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2680;